export default {
  path: '/profile_strategy_qualities',
  name: 'profile_strategy_qualities',
  component: () => import('../components/profilestrategyquality/Layout'),
  redirect: { name: 'ProfileStrategyQualityList' },
  children: [
    /*
    {
      name: 'ProfileStrategyQualityList',
      path: '',
      component: () => import('../views/profilestrategyquality/List')
    },
    {
      name: 'ProfileStrategyQualityCreate',
      path: 'new',
      component: () => import('../views/profilestrategyquality/Create')
    },
    {
      name: 'ProfileStrategyQualityUpdate',
      path: ':id/edit',
      component: () => import('../views/profilestrategyquality/Update')
    },
    {
      name: 'ProfileStrategyQualityShow',
      path: ':id',
      component: () => import('../views/profilestrategyquality/Show')
    }
    */
  ]
};
